import { useState } from "react";
import ApiFetch from "../../services/api.fetch";
import { URLS } from "../../utils/url";

import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VideocamIcon from "@mui/icons-material/Videocam";
import theme from "../../styles/styleTheme";

export const useStages = () => {
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({
    message: "",
    status: false,
  });

  const getData = async (
    id: number | string,
  ): Promise<any | null | undefined> => {
    try {
      const data = await ApiFetch.httpGet(URLS.get.tenant.stages);

      setData(data);
      return data;
    } catch (err) {
      setError({
        status: true,
        message: "Something went wrong",
      });
      throw new Error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getStageById = (stageId: number) => {
    if (data) {
      return data.find((stage: any) => stage.id === stageId);
    }
  };

  const getStageByName = (stageName: number) => {
    if (data) {
      return data.find((stage: any) => stage.name === stageName);
    }
  };

  const getStageIcon = (stageKey: string) => {
    if (!stageKey) return null;
    const stageKeyLower = stageKey.toLowerCase();
    const style = {
      color: theme.palette.primary.main,
    };
    switch (stageKeyLower) {
      case "rejected":
        return <CloseIcon style={style} />; //Rejected
      case "interested":
        return <RemoveRedEyeIcon style={style} />; //Interested
      case "videoviewing":
        return <VideocamIcon style={style} />; //Property video
      case "viewing":
        return <RemoveRedEyeIcon style={style} />; //Viewing
      case "screening":
      case "screeninginvited":
      case "sharedcandidates":
        return <AssignmentIcon style={style} />; //Screening
      case "contract":
        return <InsertDriveFileOutlinedIcon style={style} />; //Contract
      case "checkin":
        return <CheckCircleOutlineIcon style={style} />; //Check-in
      case "rented":
        return <HomeIcon />; //Rented
      default:
        return null;
    }
  };

  const values: any = {
    data,
    error,
    loading,
    setLoading,
    setError,
    getData,
    getStageById,
    getStageByName,
    getStageIcon,
  };

  return values;
};
